import { Component, Vue } from 'types-vue'
import Contact from '../../_models/Contact'
import CCPService from '../../Services/CCP'
import moment from 'moment'
import _ from 'lodash'

@Component
export default class ContactData extends Vue {
  

  /**
   * STATE
   */

  protected contact: Contact | null = null


  /**
   * PROCE
   */

  get haveAttributes(): boolean {
    if (!this.contact) return false
    return !_.isEmpty(this.contact.attributes);  
  }


  /**
   * METHODS
   */

  private setContactEvents(contact: connect.Contact) {
    contact.onEnded(this.onEndedContact.bind(this))
    contact.onRefresh(this.onUpdateContact.bind(this))
  }

  private updateContactToState(contact: connect.Contact | null) {
    
    if (!contact) {
      this.contact = null
      return
    }
    
    moment.locale('es-es');
    
    this.contact = {
      contactId: contact.contactId,
      queue: contact.getQueue().name,
      state: contact.getState().type,
      stateTime: moment(contact.getState().timestamp),
      attributes: contact.getAttributes()
    }
  }

  // {
  //   label: 'Level one 1',
  //   children: [{
  //     label: 'Level two 1-1',
  //     children: [{
  //       label: 'Level three 1-1-1'
  //     }]
  //   }]
  // }

  get contactAttributes() {
    if (!this.contact) return {}
    
    const data = this.contact.attributes

    const parseElement = (key: any, value: any, copyValue: any): any => {
      const newCopyValue = `${copyValue}.${key}`

      if (_.isObjectLike(value)) {
        return {
          label: key,
          children: Object.keys(value).map((key2) =>  parseElement(key2, value[key2], newCopyValue))
        }
      } else {
        return { label: key, value: value, copyValue: `{{${newCopyValue}}}` }
      }
    }

    return Object.keys(data).map((key) => parseElement(key, data[key], 'query1')) 
  }



  /**
   * EVENTS
   */

  private onUpdateContact(contact: connect.Contact) {
    this.updateContactToState(contact)
  }

  private onEndedContact() {
    this.updateContactToState(null)
  }

  private onNewContact(contact: connect.Contact) {
    this.setContactEvents(contact)
    this.updateContactToState(contact)
  }


  /**
   * VUE EVENTS CYCLE
   */

  mounted() {
    CCPService.subscribeContact(this.onNewContact.bind(this))
  }
}